module.exports = __webpack_public_path__ + "img/zcyg-title.04faab05.png";